import { useDispatch, useSelector, useStore } from "react-redux";
// `store` is imported as a *type* so `typeof store` works without pulling the
// store's runtime module into this one — which would create an import cycle.
import type { AppDispatch, RootState, store } from "./store";

/**
 * Pre-typed hooks. Use these everywhere instead of the bare react-redux ones —
 * `useSelector` untyped silently gives you `any` for the whole state tree.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<typeof store>();
